import { identity, useContextSelector } from '@web-stories-wp/react';
import Context from './context';

function useExternalMedia(selector) {
  return useContextSelector(Context, selector ?? identity);
}

export default useExternalMedia;
